import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Auth } from '../../helpers'

class Banner extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hours: '',
      minutes: '',
      running: false
    }
  }

  componentDidMount () {
    const { startTimers, endTimers } = this.props.schedules

    let countDownDate = new Date(startTimers[this.props.location]).getTime()

    if (new Date() > new Date(startTimers[this.props.location])) {
      countDownDate = new Date(endTimers[this.props.location]).getTime()
      this.setState({ running: true })
    }

    const timerFunc = () => {
      let now = new Date().getTime()
      let distance = countDownDate - now

      let days = Math.floor(distance / (1000 * 60 * 60 * 24))

      let hours = days * 24 + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      minutes = minutes < 10 && minutes >= 0 ? '0' + minutes : minutes
      minutes = minutes < 0 ? '00' : minutes
      hours = hours < 10 && hours >= 0 ? '0' + hours : hours
      hours = hours < 0 ? '00' : hours

      this.setState({ hours: hours, minutes: minutes })

      if (distance < 0 && this.timer) {
        clearInterval(this.timer)
        this.setState({ hours: '00', minutes: '00' })
      }
    }

    timerFunc()

    this.timer = setInterval(timerFunc, 1000)
  }

  componentWillUnmount () {
    clearInterval(this.timer)
  }

  render () {
    const adminTeamIds = this.props.teams.filter(t => t.name === 'Adidas Team' || t.name === 'FidWeb').map(t => t.id)
    const players = this.props.players.filter(p => adminTeamIds.indexOf(p.team) === -1)

    return (
      <div className='main-col-cell'>
        <div className='dashboard-hellow'>
          <p className='heretocreate'>#HERETOCREATE</p>
          <h1>Hello,<br />{Auth.getUser() && Auth.getUser().location.split(' ')[0]}</h1>

          <div className='counters'>
            <div>
              <div className='number'>{players.length}</div>
              <h4>Players</h4>
            </div>
            <div>
              <div className='number'>{this.props.teams.length - 2}</div>
              <h4>Teams</h4>
            </div>
            <div>
              <div className='number'>{this.state.hours}:{this.state.minutes}</div>
              <h4>{this.state.running && 'Hacking '}Hours left</h4>
            </div>
          </div>

          <div>
            <button onClick={() => {
              this.props.dispatch({
                type: 'popup/SWITCH_EMAIL_INVITE'
              })
            }} className='button'>INVITE PLAYERS</button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.auth.user.location,
    players: state.participants,
    teams: state.team.teams,
    schedules: state.general.schedules
  }
}

export default connect(mapStateToProps)(Banner)



// WEBPACK FOOTER //
// ./src/screens/dashboard/Banner.js